import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import css from 'stylesheets/common/_modal.module.less';
import RegistryVisibility from './RegistryVisibility';
import PageVisibility from './PageVisiblity';

class HidePagesModal extends Component {
  constructor(props) {
    super(props);

    this.shouldShowRegistrySection = this.shouldShowRegistrySection.bind(this);
    this.togglePage = this.togglePage.bind(this);
    this.publishWebsite = this.publishWebsite.bind(this);
    this.publishRegistry = this.publishRegistry.bind(this);
    this.setShippingAddressSuccess = this.setShippingAddressSuccess.bind(this);
    this.checkWeddingDateBeforePublish = this.checkWeddingDateBeforePublish.bind(this);

    this.state = {
      showRegistrySection: true,
      registryPublished: false,
      pagesToHide: {},
      orderedIds: [],
      showButtonSuccess: false,
    };
  }

  componentWillMount() {
    const { registryIds, registry } = this.props;
    if (registryIds.length > 0) {
      this.setState({
        showShippingAddressForm: !registry.has_shipping_address,
        registryPublished: registry.is_public,
      });
    }
  }

  componentDidMount() {
    const { getHiddenPageSuggestions } = this.props;
    getHiddenPageSuggestions();
  }

  componentWillReceiveProps(nextProps) {
    const { registry, registryIds } = this.props;
    const { pages } = nextProps;
    const { orderedIds } = this.state;
    if (orderedIds.length === 0) {
      const visiblePages = _.omitBy(
        pages.hideablePagesById,
        page => page.hidden || (page.type === 'REGISTRY' && registry.is_public)
      );
      const visibleIds = _.filter(pages.orderedHideablePageIds, id => _.has(visiblePages, id));
      if (visibleIds && visibleIds.length > 0) {
        this.setState({
          pagesToHide: _.mapValues(visiblePages, visiblePage =>
            _.merge({}, visiblePage, { hidden: true })
          ),
          orderedIds: _.filter(pages.orderedHideablePageIds, id => _.has(visiblePages, id)),
        });
      } else if (registryIds.length === 0 || registry.is_public || !registry.is_public) {
        this.checkWeddingDateBeforePublish();
      }
    }
    if (orderedIds.length > 0 && !registry.is_public && nextProps.registry.is_public) {
      const visiblePages = _.omitBy(
        pages.hideablePagesById,
        page => page.hidden || (nextProps.registry.is_public && page.type === 'REGISTRY') // eslint-disable-line
      );
      const visibleIds = _.filter(pages.orderedHideablePageIds, id => _.has(visiblePages, id));
      if (visibleIds && visibleIds.length > 0) {
        this.setState({
          pagesToHide: _.mapValues(visiblePages, visiblePage =>
            _.merge({}, visiblePage, { hidden: true })
          ),
          orderedIds: _.filter(pages.orderedHideablePageIds, id => _.has(visiblePages, id)),
        });
      } else if (
        registryIds.length === 0 ||
        nextProps.registry.is_public ||
        !nextProps.registry.is_public
      ) {
        this.checkWeddingDateBeforePublish();
      }
    }
  }

  componentWillUnmount() {
    const { getPages } = this.props;
    getPages();
  }

  setShippingAddressSuccess() {
    const { onPublishRegistry } = this.props;
    const { orderedIds } = this.state;
    onPublishRegistry(true).then(() => {
      if (orderedIds.length === 0) {
        // onPublishWebsite();
        this.checkWeddingDateBeforePublish();
      } else {
        this.setState({ registryPublished: true });
      }
    });
  }

  publishRegistry() {
    const { onPublishRegistry } = this.props;
    const { orderedIds } = this.state;
    onPublishRegistry(true).then(() => {
      this.setState({ showButtonSuccess: true });
      setTimeout(() => {
        if (orderedIds.length === 0) {
          this.checkWeddingDateBeforePublish();
        } else {
          this.setState({ registryPublished: true });
        }
      }, 1000);
    });
  }

  checkWeddingDateBeforePublish() {
    const { onPublishWebsite, showWeddingDateModal, weddingDate } = this.props;
    if (weddingDate === null) {
      showWeddingDateModal();
    } else {
      onPublishWebsite();
    }
  }

  publishWebsite() {
    const { onBulkUpdatePageVisibility } = this.props;
    const { pagesToHide } = this.state;
    const updateCmsPageHiddenRequest = _.map(pagesToHide, page => ({
      id: page.id,
      hidden: page.hidden,
    }));

    onBulkUpdatePageVisibility(updateCmsPageHiddenRequest).then(this.checkWeddingDateBeforePublish);
  }

  togglePage(pageId) {
    this.setState(state => {
      const { pagesToHide } = state;
      const page = _.merge({}, pagesToHide[pageId], { hidden: !pagesToHide[pageId].hidden });
      return {
        pagesToHide: _.merge({}, pagesToHide, { [pageId]: page }),
      };
    });
  }

  shouldShowRegistrySection(showRegistrySection) {
    const { orderedIds } = this.state;
    this.setState({ showRegistrySection }, () => {
      if (orderedIds.length === 0) {
        this.checkWeddingDateBeforePublish();
      }
    });
  }

  render() {
    const { registry, hideModalFn } = this.props;
    const {
      showRegistrySection,
      showShippingAddressForm,
      orderedIds,
      pagesToHide,
      registryPublished,
      showButtonSuccess,
    } = this.state;
    return (
      <div id="hide-pages-modal">
        {registry.status === 'ACTIVE' &&
        registryPublished &&
        !registry.has_shipping_address &&
        showRegistrySection ? (
          <div id="publish-resgistry-modal">
            <RegistryVisibility
              registry={registry}
              onPublishRegistry={this.publishRegistry}
              onSetShippingAddress={this.setShippingAddressSuccess}
              onSkip={() => this.shouldShowRegistrySection(false)}
              showButtonSuccess={showButtonSuccess}
              showShippingAddressForm={showShippingAddressForm}
            />
          </div>
        ) : (
          !_.isEmpty(pagesToHide) && (
            <div id="hidden-pages" className={css.container}>
              <PageVisibility
                pages={pagesToHide}
                orderedIds={orderedIds}
                onPublishWebsite={this.publishWebsite}
                onTogglePage={this.togglePage}
                hideModalFn={hideModalFn}
              />
            </div>
          )
        )}
      </div>
    );
  }
}

HidePagesModal.propTypes = {
  pages: PropTypes.shape({
    hideablePagesById: PropTypes.shape({}),
    orderedHideablePageIds: PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    ),
  }),
  registry: PropTypes.shape({}),
  registryIds: PropTypes.arrayOf(PropTypes.string),
  getHiddenPageSuggestions: PropTypes.func.isRequired,
  onPublishRegistry: PropTypes.func,
  onPublishWebsite: PropTypes.func,
  hideModalFn: PropTypes.func,
  getPages: PropTypes.func,
  onBulkUpdatePageVisibility: PropTypes.func,
  showWeddingDateModal: PropTypes.func,
  weddingDate: PropTypes.string,
};

export default HidePagesModal;



// WEBPACK FOOTER //
// ./src/components/manage/common/HidePagesModal/HidePagesModal.jsx